import { Route } from 'react-router-dom';
import Page from '../../components/Page/index.js';
import Teams from './Teams.js';
import Team from './Team.js';
import Player from './Player.js';
import NewTeam from './NewTeam.js';
import NewPlayer from './NewPlayer.js';
import NewStaffMember from './NewStaffMember.js';
import Paths from '../../constants/paths.js';
import ErrorMessages from '../../components/ErrorMessages.js/index.js';
import { observer } from 'mobx-react-lite';

import StaffMember from './StaffMember.js';

const TeamsChlTab = ({ store }) => {
    return (
        <Page loading={!store.dataLoaded}>
            <div style={{ marginLeft: '2.5%' }}>
                <ErrorMessages messages={store.error} />
            </div>
            <Route exact path={Paths.TEAMS_CHL}>
                <Teams store={store} />
            </Route>
            <Route exact path={Paths.TEAM_CHL}>
                <Team store={store} />
            </Route>
            <Route exact path={Paths.TEAM_PLAYER_CHL}>
                <Player store={store} />
            </Route>
            <Route exact path={Paths.NEW_TEAM_CHL}>
                <NewTeam store={store} />
            </Route>
            <Route exact path={Paths.TEAM_NEW_PLAYER_CHL}>
                <NewPlayer store={store} />
            </Route>
            <Route exact path={Paths.NEW_STAFF_MEMBER_CHL}>
                <NewStaffMember store={store} />
            </Route>
            <Route exact path={Paths.STAFF_MEMBER_CHL}>
                <StaffMember store={store} />
            </Route>
        </Page>
    );
};

export default observer(TeamsChlTab);
